var animate    = require("patternity/lib/utilities/animate");

var AnimateCardReshuffle = function(){
  function run(challengeId, cardToRemove){
    if(animate.isAnimationSupported()){
      performAnimation(challengeId, cardToRemove);
    } else {
      $(cardToRemove).css("display", "none");
    }
  }

  function performAnimation(challengeId, cardToRemove){
    var cardsToAnimate = $(cardToRemove).nextAll().andSelf();

    cardsToAnimate.each(function(index){
      var card = this;
      var callback = function(){};

      if(index === 1) {
        callback = function(){
          $(cardToRemove).css("display", "none");
        };
      }

      slideCardLeft(card, callback);
    });
  }

  function slideCardLeft(card, callback){
    var cardLeftPosition = 0;
    var animationStopPosition = $(card).outerWidth() * -1;

    requestAnimationFrame(updateCardStyles);

    function updateCardStyles() {
      card.style.transform = 'translate3d(' + cardLeftPosition + 'px, 0, 0)';
      card.style['-webkit-transform'] = 'translate3d(' + cardLeftPosition + 'px, 0, 0)';
      card.style['-ms-transform'] = 'translate3d(' + cardLeftPosition + 'px, 0, 0)';

      if (cardLeftPosition > -250) {
        cardLeftPosition = cardLeftPosition - 30;
        requestAnimationFrame(updateCardStyles);
      } else {
        card.style.transform = 'translate3d(0px, 0, 0)';
        card.style['-webkit-transform'] = 'translate3d(0px, 0, 0)';
        card.style['-ms-transform'] = 'translate3d(0px, 0, 0)';
        callback();
      }
    }
  }

  return {
    run : run
  };
};

module.exports = new AnimateCardReshuffle();



// WEBPACK FOOTER //
// ./src/advocate/challenges/animations/animate_card_reshuffle.js